import { Observable } from 'rxjs';
import { UserModel } from '../models/user/user.model';
import { UserRequestModel } from '../models/user/user-request.model';
import { UserOtpModel } from '../models/user/user-otp.model';
import { UserValidateOtpModel } from '../models/user/user-validate-otp.model';
import { UserChangePasswordModel } from '../models/user/user-change-password.model';
import { UserRecaptchaValidateModel } from '../models/user/user-recaptcha-validate.model';
import { UserTourModel } from '../models/user/user-tour.model';
import { UserProfileModel } from '../models/user/user-profile.model';
import { DataBasicProfileModel } from '../models/user/data-basic-profile.model';
import { DataBasicProfileResultModel } from '../models/user/data-basic-profile-result.model';
import { ProfilePhotoModel } from '../models/user/profile-photo.model';
import { ProfileResponseModel } from '../models/user/profile-response.model';
export abstract class  UserRepository {
    abstract loginUser(params:UserRequestModel):Observable<UserModel>;
    abstract sendOtpChangePassword(params:{nombreUsuario:string}):Observable<UserOtpModel>;
    abstract validateOtpChangePassword(params:{usuario:string, OTP:string}):Observable<UserValidateOtpModel>;
    abstract changePassword(params:{usuario:string, password:string}):Observable<UserChangePasswordModel>;
    abstract validateRecaptcha(params:{recaptcha:string}):Observable<UserRecaptchaValidateModel>;
    abstract getStateTour(): Observable<UserTourModel>;
    abstract getUserProfile(): Observable<UserProfileModel>;
    abstract updatePersonalInfoProfile(params:DataBasicProfileModel):Observable<DataBasicProfileResultModel>;
    abstract updateProfilePhoto(archivo: File): Observable<ProfileResponseModel>;
    abstract getProfilePhoto():Observable<ProfilePhotoModel>;
    abstract deleteProfilePhoto():Observable<ProfileResponseModel>;
}
